import { render, staticRenderFns } from "./JFormContainer.vue?vue&type=template&id=4d757dc4"
import script from "./JFormContainer.vue?vue&type=script&lang=js"
export * from "./JFormContainer.vue?vue&type=script&lang=js"
import style0 from "./JFormContainer.vue?vue&type=style&index=0&id=4d757dc4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d757dc4')) {
      api.createRecord('4d757dc4', component.options)
    } else {
      api.reload('4d757dc4', component.options)
    }
    module.hot.accept("./JFormContainer.vue?vue&type=template&id=4d757dc4", function () {
      api.rerender('4d757dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JFormContainer.vue"
export default component.exports